import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@assets/MeDaPro_logo.svg'


const _hoisted_1 = { class: "h-100 d-flex flex-column flex-full-height" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo-main logo-nav-bar",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "content-container" }
const _hoisted_5 = {
  class: "content-inner-container",
  "data-cy": "main-content-container"
}
const _hoisted_6 = {
  id: "app",
  class: "home"
}

import ContextMenubar from "@common/components/MenuBar/ContextMenuBar.vue";
import BasicLayoutSidebar from "@common/components/ModuleSidebar.vue";
import ApplicationSettings from "@common/components/OptionsMenus/ApplicationSettings.vue";
import SaveState from "@common/components/SaveState.vue";
import SimpleSearch from "@common/components/SimpleSearch.vue";
import { useUser } from "@common/composable/useRootStore";
import SignalRNotifier from "@common/views/SignalRNotifier.vue";
import { getInitials } from "@util/user";
import { computed, inject, onBeforeUnmount, onMounted, ref } from "vue";
import { useState } from "vuex-composition-helpers";
import { RootState } from "@medapro-types/common/rootstate";


export default /*#__PURE__*/_defineComponent({
  __name: 'Client',
  setup(__props) {

const { user } = useUser();
const { jwt } = useState<RootState>(["jwt"]);

const $startSignalR = inject<(token: string) => void>("$startSignalR");
const $stopSignalR = inject<() => void>("$stopSignalR");

const showSettingsMenu = ref(false);

const avatarText = computed(() => {
  return getInitials(user.value.username);
});

const avatarImage = computed(() => {
  if (user.value.image) {
    return "data:image/png;base64," + user.value.image;
  } else {
    return null;
  }
});

// Methods
const hideSettingsMenu = () => {
  showSettingsMenu.value = false;
};

onMounted(() => {
  if ($startSignalR) $startSignalR(jwt.value.token);
});

onBeforeUnmount(() => {
  if ($stopSignalR) $stopSignalR();
});

return (_ctx: any,_cache: any) => {
  const _component_b_navbar_brand = _resolveComponent("b-navbar-brand")!
  const _component_b_nav_form = _resolveComponent("b-nav-form")!
  const _component_b_navbar_nav = _resolveComponent("b-navbar-nav")!
  const _component_b_navbar_toggle = _resolveComponent("b-navbar-toggle")!
  const _component_b_avatar = _resolveComponent("b-avatar")!
  const _component_b_nav_text = _resolveComponent("b-nav-text")!
  const _component_b_navbar = _resolveComponent("b-navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_on_click_outside = _resolveDirective("on-click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_navbar, {
      id: "navigation-bar",
      class: "top-nav-bar bg-navbar",
      toggleable: "lg"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_navbar_brand, { to: { name: 'dashboard' } }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_b_navbar_nav, { class: "navbar-nav-search" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_nav_form, null, {
              default: _withCtx(() => [
                _createVNode(SimpleSearch, {
                  ref: "simpleSearch",
                  class: "navbar-nav-simple-search"
                }, null, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_navbar_toggle, { target: "nav-collapse" }),
        _createVNode(_component_b_navbar_nav, { class: "ml-auto" }, {
          default: _withCtx(() => [
            _createVNode(SaveState),
            _withDirectives((_openBlock(), _createBlock(_component_b_nav_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_avatar, {
                  square: "",
                  src: avatarImage.value,
                  class: _normalizeClass({ 'no-image': !avatarImage.value }),
                  text: avatarText.value,
                  button: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showSettingsMenu.value = !showSettingsMenu.value), ["prevent"])),
                  "data-cy": "app-settings-btn"
                }, null, 8, ["src", "class", "text"]),
                _withDirectives(_createVNode(ApplicationSettings, {
                  onClose: _cache[1] || (_cache[1] = ($event: any) => (showSettingsMenu.value = false))
                }, null, 512), [
                  [_vShow, showSettingsMenu.value]
                ])
              ]),
              _: 1
            })), [
              [_directive_on_click_outside, hideSettingsMenu]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(BasicLayoutSidebar),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ContextMenubar),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_view, { ref: "routerView" }, null, 512)
          ])
        ])
      ])
    ]),
    _createVNode(SignalRNotifier)
  ]))
}
}

})